import JSON_Intro from "./JavaScript/JSON_Intro.jsx";
import JSON_Syntax from "./JavaScript/JSON_Syntax.jsx";
import JSON_vs_XML from "./JavaScript/JSON_vs_XML.jsx";
import JSON_Data_Types from "./JavaScript/JSON_Data_Types.jsx";
import JSON_Parse from "./JavaScript/JSON_Parse.jsx";
import JSON_Stringify from "./JavaScript/JSON_Stringify.jsx";
import JSON_Objects from "./JavaScript/JSON_Objects.jsx";
import JSON_Arrays from "./JavaScript/JSON_Arrays.jsx";
import JSON_Server from "./JavaScript/JSON_Server.jsx";
import JSON_PHP from "./JavaScript/JSON_PHP.jsx";
import JSON_HTML from "./JavaScript/JSON_HTML.jsx";
import JSON_JSONP from "./JavaScript/JSON_JSONP.jsx";

const jsonJsComponentsMap = {
  "<JSON_Intro />": JSON_Intro,
  "<JSON_Syntax />": JSON_Syntax,
  "<JSON_vs_XML />": JSON_vs_XML,
  "<JSON_Data_Types />": JSON_Data_Types,
  "<JSON_Parse />": JSON_Parse,
  "<JSON_Stringify />": JSON_Stringify,
  "<JSON_Objects />": JSON_Objects,
  "<JSON_Arrays />": JSON_Arrays,
  "<JSON_Server />": JSON_Server,
  "<JSON_PHP />": JSON_PHP,
  "<JSON_HTML />": JSON_HTML,
  "<JSON_JSONP />": JSON_JSONP,
};

export default jsonJsComponentsMap;
